<!-- filter-tags.component.html -->
<div class="w-full">
  <div
    class="flex items-center gap-1 rounded-md bg-white px-3 outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-blue-royal w-full h-[36px]"
    [class.outline-red-500]="required && control?.errors?.['required'] && control?.touched"
  >
    <!-- Existing Tags -->
    <div *ngFor="let tag of tags; let i = index" class="bg-gray-100 text-gray-700 rounded-md px-2 py-0.5 flex items-center text-sm">
      {{ tag }}
      <button type="button" (click)="removeTag(i)" class="ml-1 inline-flex size-4 shrink-0 rounded-full p-1 text-gray-500 hover:opacity-90">
        <span class="sr-only">Remove filter for {{ tag }}</span>
        <svg class="size-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
          <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7" />
        </svg>
      </button>
    </div>

    <!-- Input -->
    <input
      #tagInput
      type="text"
      [(ngModel)]="inputValue"
      [placeholder]="tags.length ? '' : placeholder"
      class="flex-grow outline-none min-w-[120px] bg-white text-gray-900 border-none focus:ring-0 focus:outline-none placeholder:text-sm placeholder:text-gray-400 text-sm leading-none h-full"
      (keydown)="handleKeydown($event)"
      (blur)="addTagFromInput()"
    >
  </div>

  <div *ngIf="required && control?.errors?.['required'] && control?.touched" class="text-red-500 text-xs mt-1">
    This field is required
  </div>
</div>
